module.exports = __webpack_public_path__ + "static/media/ofuroSenpatsu.341d5cfd.png";